import React from "react";
import { maxLength, minLength, required } from "react-admin";
import { TextInput } from "react-admin";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";
import "../../common/styles/TwoInputsInRow.css";

export const NameAndSurnameInput = (props: any) => {
  return (
    <div className="two-inputs-container">
      <ProtectedElement source="name">
        <TextInput
          source="name"
          label="resources.admin-drivers.labels.name"
          validate={[required(), minLength(2), maxLength(30)]}
          autoComplete="given-name"
          {...props}
        />
      </ProtectedElement>
      <ProtectedElement source="surname">
        <TextInput
          source="surname"
          label="resources.admin-drivers.labels.surname"
          validate={[required(), minLength(2), maxLength(30)]}
          autoComplete="family-name"
          {...props}
        />
      </ProtectedElement>
    </div>
  );
};
